var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"padding":"40px"}},[_c('v-icon',{staticStyle:{"font-size":"200px"}},[_vm._v("mdi-account-hard-hat")]),_c('header',{staticStyle:{"font-weight":"bold","font-size":"24px","margin-bottom":"20px"}},[_vm._v(" Site Maintenance in Progress ")]),_c('p',[_vm._v(" We're making some improvements, please check back later ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }